import React from 'react';
import SimulationsHeader from './components/SimulationsHeader';
import SimulationsTable from './components/SimulationsTable';
import appStyles from '../Routes.css';

const Simulations = () => {
    return (
        <div className={appStyles.landingPage}>
            <SimulationsHeader />
            <SimulationsTable />
        </div>
    );
};

export default Simulations;
